'use strict';

const elementInViewport = require('./modules/util/elementInViewport');

const animBlockEl = '.js-anim-block';
const animQueuedEl = '.js-anim-queued';

let onScrollTimeout;

const initAnimBlocks = () => {
    const observer = new IntersectionObserver((blocks) => {
        for (const block of blocks) {
            const $el = $(block.target);

            if (block.isIntersecting === true) {
                $el.removeClass('not-in-viewport');
                $el.addClass('in-viewport');
            } else {
                $el.removeClass('in-viewport');
                $el.addClass('not-in-viewport');
            }
        }
    }, {
        threshold: [0.05]
    });

    $(animBlockEl).each(function(i, el) {
        observer.observe(el);
    });
};

const supportsIntersectionOberver = () => {
    return 'IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};

const bindEvents = () => {
    if ($(animBlockEl).length > 0) {
        $(window).on('scroll', onScrollWindow);
        handleInitialPageView();
    }
};

const onScrollWindow = () => {
    clearTimeout(onScrollTimeout);
    onScrollTimeout = setTimeout(handleOnScrollWindow, 10);
};

const handleOnScrollWindow = () => {
    $(animBlockEl).each(function(index, el) {
        handleAnimationClass(el);
    });
};

const handleInitialPageView = () => {
    $(animBlockEl).not(animQueuedEl).each(function(index, el) {
        handleAnimationClass(el);
    });
};

const handleAnimationClass = (el) => {
    if (elementInViewport(el, 0)) {
        $(el).removeClass('not-in-viewport');
        $(el).addClass('in-viewport');
    } else {
        $(el).removeClass('in-viewport');
        $(el).addClass('not-in-viewport');
    }
};

const animBlock = {
    init: () => {
        if (supportsIntersectionOberver()) {
            initAnimBlocks();
        } else {
            bindEvents();
        }
    }
};

module.exports = animBlock;
